import { theme } from '@Guidelines/Theme/theme';

const colorsByToken: Readonly<Record<string, string>> = theme.subjectTypeColors;

/** Color of a subject type; an unknown token falls back to cyan. */
const resolveSubjectTypeColor = (value: string): string => {
	return colorsByToken[value] ?? theme.subjectTypeColors.cyan;
};

export default resolveSubjectTypeColor;
